export const firebaseConfigWeb = {
    apiKey: 'AIzaSyBaCJ8LzEbFYgnUBZYm12EQttMEZSDINa8',
    authDomain: 'tin88-wap.firebaseapp.com',
    projectId: 'tin88-wap',
    storageBucket: 'tin88-wap.appspot.com',
    messagingSenderId: '708836044947',
    appId: '1:708836044947:web:19f729cad10ae0f002dd66',
    measurementId: 'G-S99Z33QKN5',
};
